import { render, staticRenderFns } from "./CommunicationChannelModal.vue?vue&type=template&id=8d17e790&"
import script from "./CommunicationChannelModal.vue?vue&type=script&lang=js&"
export * from "./CommunicationChannelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports